;(function () {
  const BAR_ID = "memree-bundle-progress";
  const COUNT_ID = "memree-bundle-progress-count";

  const BUNDLE_WRAPPER_SELECTOR = ".gbbMixCascadeWrapper";
  const PRODUCT_CARD_SELECTOR = ".gbbMixCascadeProductWrapper";
  const QTY_ATTR = "data-product-quantity";

  if (!document.getElementById(BAR_ID)) return;

  if (window.__memreeBundleQtyCounterInit) return;
  window.__memreeBundleQtyCounterInit = true;

  let rafQueued = false;

  function getMaxFromCounter(countEl) {
    const text = countEl?.textContent || "";
    const parts = text.split("/");
    const max = parseInt(parts[1], 10);

    return Number.isFinite(max) ? max : 0;
  }

  function getSelectedCount(bundleRoot) {
    const cards = (bundleRoot || document).querySelectorAll(PRODUCT_CARD_SELECTOR);
    let total = 0;

    cards.forEach((card) => {
      const raw = card.getAttribute(QTY_ATTR);
      const n = raw ? parseInt(raw, 10) : 0;

      if (Number.isFinite(n)) total += n;
    });

    return total;
  }

  function render() {
    const bar = document.getElementById(BAR_ID);
    const countEl = document.getElementById(COUNT_ID);

    if (!bar || !countEl) return;

    const bundleRoot = document.querySelector(BUNDLE_WRAPPER_SELECTOR);
    const max = getMaxFromCounter(countEl);
    const selected = getSelectedCount(bundleRoot);

    countEl.textContent = `${selected}/${max}`;

    bar.classList.toggle("is-complete", max > 0 && selected >= max);
  }

  function scheduleRender() {
    if (rafQueued) return;

    rafQueued = true;

    requestAnimationFrame(() => {
      rafQueued = false;
      render();
    });
  }

  function watchBundle() {
    const bundleRoot = document.querySelector(BUNDLE_WRAPPER_SELECTOR);
    if (!bundleRoot) return false;

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === "attributes" && mutation.attributeName === QTY_ATTR) {
          scheduleRender();
          return;
        }

        if (mutation.type === "childList") {
          scheduleRender();
          return;
        }
      }
    });

    observer.observe(bundleRoot, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: [QTY_ATTR],
    });

    scheduleRender();
    return true;
  }

  function init() {
    render();

    if (watchBundle()) return;

    let tries = 0;

    const timer = setInterval(() => {
      tries += 1;

      if (watchBundle() || tries > 80) {
        clearInterval(timer);
        scheduleRender();
      }
    }, 100);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();